module.exports = __webpack_public_path__ + "static/media/COLA2018004.1809cb2e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/PDFFiles/COLA2018004.pdf
// module id = 2267
// module chunks = 1